import { render, staticRenderFns } from "./MappingPlayground.vue?vue&type=template&id=2bdd5c50&"
import script from "./MappingPlayground.vue?vue&type=script&lang=ts&"
export * from "./MappingPlayground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports